// extracted by mini-css-extract-plugin
export default {"productGallery":"bG-z","inQuickShop":"cG-z"};